import { SectionHeader } from "@/components/ui/SectionHeader";
import { VerticalTimeline, type TimelineStep } from "@/components/ui/VerticalTimeline";

const INTENT_STEPS: TimelineStep[] = [
  {
    step: "1",
    title: "Intent 作成",
    description:
      "金額（JPY）、受取チェーン、ウォレットアドレスを指定して ステーブルコイン 発行の申請を作成します。専用のバーチャル口座（振込先）が即座に発行されます。",
    badge: "POST /v1/intents",
  },
  {
    step: "2",
    title: "日本円の入金",
    description:
      "エンドユーザーが提示されたバーチャル口座へ銀行振込を実行。入金通知（Webhook）を受けて申請金額との照合が自動で行われます。",
    badge: "入金 → 自動照合",
  },
  {
    step: "3",
    title: "ステーブルコイン 送付・完了",
    description:
      "照合完了後、指定ウォレットへ ERC-20 ステーブルコインを送付。ステータスは PENDING_DEPOSIT → DEPOSITED → COMPLETED と遷移し、すべて API で追跡できます。",
    badge: "オンチェーン送金",
  },
];

const REDEMPTION_STEPS: TimelineStep[] = [
  {
    step: "1",
    title: "Redemption 作成",
    description:
      "払い戻し金額（ステーブルコイン）を指定して申請を作成。ステーブルコイン 受取用の専用入金アドレスが生成されます。",
    badge: "POST /v1/redemptions",
  },
  {
    step: "2",
    title: "ステーブルコイン の送付・検知",
    description:
      "エンドユーザーが ステーブルコイン を専用アドレスへ送付。外部インデクサがオンチェーンの Transfer を検知し、確認数（confirmations）が閾値に達すると入金確定となります。",
    badge: "CryptoDetected → Confirmed",
  },
  {
    step: "3",
    title: "日本円の払い戻し",
    description:
      "入金確定後、登録済み銀行口座へ日本円を振込。ステータスは JPY 払戻処理中 → Completed と遷移し、完了まで追跡できます。",
    badge: "銀行振込",
  },
];

export function MbscHowItWorks() {
  return (
    <section className="border-t border-border/60 bg-muted/20 px-6 py-20 md:px-12">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          eyebrow="How It Works"
          title="入金も払い戻しも 3 ステップで完結。"
          description="日本円→ステーブルコイン（Intent）と ステーブルコイン→日本円（Redemption）の 2 つのフローを提供。
            どちらもエンドユーザーの操作はシンプルに保ちつつ、
            入金照合やオンチェーン検知はすべて MBSC が処理します。"
        />
        <h3 className="mt-14 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
          日本円 → ステーブルコイン（Intent）
        </h3>
        <VerticalTimeline steps={INTENT_STEPS} className="mt-6" />
        <h3 className="mt-16 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
          ステーブルコイン → 日本円（Redemption）
        </h3>
        <VerticalTimeline steps={REDEMPTION_STEPS} className="mt-6" />
      </div>
    </section>
  );
}
